<template>
  <div
    :class="['wptv-aside', { opened }]"
    @click="close">
    <transition
      name="aside"
      @after-enter="$emit('open-transition-end')"
      @after-leave="$emit('close-transition-end')">
      <nav
        v-if="opened"
        class="nav"
        @click.stop>
        <slot />
      </nav>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'WptvAside',
  data () {
    return {
      opened: false
    }
  },
  methods: {
    /* TODO
    The method close is called even if the aside is not opened.
    It may be great to change this.
    */
    close () {
      this.opened = false
      this.$emit('closed')
    },
    open () {
      this.opened = true
      this.$emit('opened')
    }
  }
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '../../../scss/abstracts/variables';

.wptv-aside {
  position: fixed;
  top: 0;
  z-index: 97;
  width: 100%;
  height: 100%;
  overflow: hidden;
  pointer-events: none;

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    opacity: 0;
    will-change: opacity;
    transition: opacity 0.3s cubic-bezier(0, 0 , 0.3, 1);
  }

  li {
    padding: 10px;

    &:not(:first-child) {
      border-top: 1px solid $lightgrey;
    }

    &:hover {
      background: #ddd;
    }

    a {
      display: block;
    }
  }

  .nav {
    position: relative;
    max-width: 400px;
    width: 90%;
    height: 100%;
    overflow: auto;
    background-color: #fff;
    box-shadow: 2px 0 12px rgba(0, 0, 0, 0.4);
    will-change: transform;

    &.aside-enter-active,
    &.aside-leave-active {
      transition: transform 0.13s cubic-bezier(0, 0, 0.3, 1);
    }

    &.aside-enter,
    &.aside-leave-to {
      transform: translateX(-102%);
    }

    &.aside-leave,
    &.aside-enter-to {
      transform: translateX(0%);
    }

  }

  .help-entry {
    cursor: pointer;
  }

  .help-title {
    display: flex;
    align-items: center;
    font-size: 1.6rem;
    cursor: pointer;
  }
}

.opened {
  &.wptv-aside {
    pointer-events: all;
  }

  &.wptv-aside::before {
    opacity: 1;
  }
}
</style>
